const dev = {
	baseURL: "http://localhost:3080/api/",
	landingPageUrl: "http://localhost:3080",
	stripe: {
		free: "price_1MMm7sE9R7zw5FGBFABUB7dH",
		entry: "price_1MMmDuE9R7zw5FGBr5ZogG0K",
		pro: "price_1MN85zE9R7zw5FGBgVGauRfN"
	},
};
  
const prod = {
	baseURL: '/api/',
	landingPageUrl: "https://app.openaitemplate.com",
	stripe: {
		free: "price_1MMm7sE9R7zw5FGBFABUB7dH",
		entry: "price_1MMmDuE9R7zw5FGBr5ZogG0K",
		pro: "price_1MN85zE9R7zw5FGBgVGauRfN"
	},
};
  
const config = process.env.NODE_ENV === 'development'
	? dev
	: prod;
  
export default config;